import {
  Component, OnInit, Inject, Injector, Optional, NgZone, ElementRef, forwardRef,
  NgModule,
  ViewEncapsulation
} from '@angular/core';
import { EventEmitter } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/mergeAll';
import { OntimizeService, DialogService, OFormComponent, InputConverter, Util, ObservableWrapper, OSharedModule } from 'ontimize-web-ngx';

import { OLightTableButtonPanelModule } from './o-light-table-button-panel.component';
import { OLightTableColumnModule, OLightTableColumnComponent } from './o-light-table-column.component';

import { CommonModule } from '@angular/common';

export const DEFAULT_INPUTS_O_LIGHT_TABLE = [
  'refreshButton: refresh-button',
  'queryOnInit: query-on-init',
  'columns',
  'parentKeys: parent-keys',
  'entity',
  'service',
  'key',
  'route',
  //static-data [Array<any>] : way to populate with static data. Default: no value.
  'staticData: static-data'
];

export const DEFAULT_OUTPUTS_O_LIGHT_TABLE = [
  'onRowClick'
];


export class OLightTableComponent implements OnInit {

  public static DEFAULT_INPUTS_O_LIGHT_TABLE = DEFAULT_INPUTS_O_LIGHT_TABLE;
  public static DEFAULT_OUTPUTS_O_LIGHT_TABLE = DEFAULT_OUTPUTS_O_LIGHT_TABLE;

  /* Inputs */
  columns: string;
  parentKeys: string;
  entity: string;
  service: string;
  key: string;
  route: string;
  @InputConverter()
  queryOnInit: boolean = true;
  @InputConverter()
  refreshButton: boolean = true;
  @InputConverter()
  showControls: boolean = true;

  staticData: Array<any>;

  /*End inputs */

  markAll: boolean = false;
  selected: any[] = [];
  deleting: boolean = false;
  dataArray: any[] = [];
  serviceData: any[] = [];
  colArray: string[] = [];
  oColumns: Object = {};

  public onRowClick: EventEmitter<any> = new EventEmitter();

  protected dataService: any;

  private _injector;
  private _dialogService: DialogService;
  private _router: Router;
  private _actRoute: ActivatedRoute;
  private elRef: ElementRef;

  private _pKeysEquiv = {};

  constructor(
    router: Router,
    actRoute: ActivatedRoute,
    el: ElementRef,
    zone: NgZone,
    injector: Injector,
      form: OFormComponent) {
    this._router = router;
    this._actRoute = actRoute;
    this.elRef = el;
    this._injector = injector;

    this._dialogService = injector.get(DialogService);
  }

  registerColumn(col: OLightTableColumnComponent) {
    if (col) {
      this.oColumns[col.id] = col;
      this.colArray.push(col.id);
    }
  }

  ngOnInit(): any {
    this.colArray = Util.parseArray(this.columns);

    //TODO Move to ParseUtils to be used on table, combo, etc....
    let pkArray = Util.parseArray(this.parentKeys);
    if (pkArray && pkArray.length > 0) {
      pkArray.forEach(item => {
        let aux = item.split(':');
        if (aux && aux.length === 2) {
          this._pKeysEquiv[aux[0]] = aux[1];
        } else if (aux && aux.length === 1) {
          this._pKeysEquiv[item] = item;
        }
      });
    }

    if (this.staticData) {
      this.dataArray = this.staticData;
    } else {
      this.configureService();
    }

  }

  configureService() {
    this.dataService = this._injector.get(OntimizeService);

    if (Util.isDataService(this.dataService)) {
      let serviceCfg = this.dataService.getDefaultServiceConfiguration(this.service);
      if (this.entity) {
        serviceCfg['entity'] = this.entity;
      }
      this.dataService.configureService(serviceCfg);
    }

  }

  ngAfterViewInit() {
    if (this.queryOnInit) {
      this.queryData();
    }
  }

  setData(data: any) {
    this.dataArray = data;
  }

  renderColumn(rowIdx: number, colIdx: number, col: string, value: any, wrapperEL: any) {
    let oColumn = this.oColumns[col];
    if (oColumn) {
      return oColumn.getRenderedValue(value);
    }
    return value;
  }

  getPipe(col: string) {
    let oColum = this.oColumns[col];
    return oColum.pipe ? oColum.pipe : '';
  }

  getFlex(col: string) {
    let oColum = this.oColumns[col];
    return oColum.flex ? oColum.flex : 'auto';
  }

  queryData(filter: Object = {}) {
    var self = this;
    this.dataService.query(filter, [], this.entity)//this.colArray
      .subscribe(resp => {
        if (resp.code === 0) {
          self.setData(resp.data);
          self.serviceData = resp.data;
        } else {
          console.log('error');
        }
      }, err => {
        console.log(err);
      });
  }

  handleMarkAll(event, selected) {
    if (this.dataArray && this.dataArray.length > 0) {
      for (let i = 0; i < this.dataArray.length; ++i) {
        let idx = this.selected.indexOf(this.dataArray[i]);
        if (!selected && idx < 0) {
          this.selected.push(this.dataArray[i]);
        } else if (selected && idx > -1) {
          this.selected.splice(idx, 1);
        }
      }
    }
  }

  syncSelected(item) {
    let idx = this.selected.indexOf(item);
    if (idx > -1) {
      this.selected.splice(idx, 1);
    } else {
      this.selected.push(item);
    }
  }

  isItemSelected(item) {
    return this.selected.indexOf(item) > -1;
  }

  onListItemClick(item, event) {

    if (!this.deleting) {
      if (this.route && this.route.length > 0) {
        let params = {};
        params[this.key] = item[this.key];
        params['isdetail'] = true;
        this._router.navigate(['/' + this.route, params]);
      }
    } else {
      this.syncSelected(item);
      if (this.markAll) {
        this.markAll = false;
      }
    }

    ObservableWrapper.callEmit(this.onRowClick, item);
  }

  public onRowClicked(onNext: (item: any) => void): Object {
    return ObservableWrapper.subscribe(this.onRowClick, onNext);
  }

  cancelRemove(event) {
    this.selected = [];
    this.markAll = false;
    this.deleting = false;
  }

  filter(event) {
    //TODO Abrir dialogo flotante para filtrar
    //-> construir formulario dinamico a partir de las columns?????
  }

  remove(event) {
    if (this.deleting) {
      this.showConfirmDelete(event);
    } else {
      this.deleting = true;
    }
  }

  add(event) {
    let params = {};
    this._router.navigate(['/New' + this.route, params]);
  }

  showConfirmDelete(evt) {
    this._dialogService.confirm('CONFIRM', 'MESSAGES.CONFIRM_DELETE')
      .then(
      res => {
        if (res === true) {
          this.executeMassiveRemove();
        }
      }
      );
  }

  executeMassiveRemove() {
    if (this.selected && this.selected.length > 0) {
      let massiveFilters = [];
      this.selected.map(item => {
        let filter = {};
        filter[this.key] = item[this.key];
        massiveFilters.push(filter);
      });
      this.removeRegister(massiveFilters);
    }
  }

  removeRegister(filter): void {

    let obs = (Observable as any).fromArray(filter)
      .map(item => this.dataService.delete(item, this.entity)).mergeAll();

    obs.subscribe(resp => {
      console.log();
    }, error => {
      this._dialogService.alert('ERROR', 'MESSAGES.ERROR_DELETE');
    }, () => {
      this._dialogService.alert('INFO', 'MESSAGES.SUCCESS_DELETE')
        .then(
        res => {
          this.deleting = false;
          this.queryData();
        }
        );
    });


  }


static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'o-light-table',
  template: `
    <ng-content *ngIf="false"></ng-content>
    <div fxFill class="container">
      <o-light-table-button-panel *ngIf="showControls"></o-light-table-button-panel>
      <md-toolbar class="o-light-table-header">
        <div class="mat-toolbar-tools">
          <md-checkbox [(checked)]="markAll" (click)="handleMarkAll($event, markAll)" aria-label="Mark all to delete" *ngIf="deleting"></md-checkbox>
          <div *ngFor="let col of colArray" class="clip-text" fxFlex="auto"> {{ oColumns[col].title }} </div>
        </div>
      </md-toolbar>
      <md-list>
        <md-list-item *ngFor="let item of dataArray; let rowIndex = index" (click)="onListItemClick(item, $event)">
          <div id="row_{{rowIndex}}" class="mat-no-style mat-list-item-inner">
            <md-checkbox [checked]="isItemSelected(item)"  aria-label="Mark to delete" *ngIf="deleting"></md-checkbox>
            <div fxLayout="row" fxFill>
              <div #colWrapper *ngFor="let col of colArray; let colIndex = index" id="col_{{rowIndex}}_{{colIndex}}"
                class="clip-text" fxFlex="auto">
                  {{ renderColumn(rowIndex, colIndex, col, item[col], colWrapper) }}
              </div>
            </div>
            <span><i class="material-icons" >navigate_next</i></span>
          </div>
          <md-divider></md-divider>
        </md-list-item>
      </md-list>
     </div>
  `,
  styles: [`
    .container{overflow-y:hidden}md-toolbar.o-light-table-header{background-color:#eee;color:rgba(0,0,0,0.87);border-top:1px solid #fff;border-bottom:1px solid #fff;padding:0px 40px 0px 0px;height:48px;min-height:48px}@media (max-width: 600px) and (min-width: 0) and (orientation: portrait){md-toolbar.o-light-table-header{top:112px}}@media (max-width: 600px) and (min-width: 0) and (orientation: landscape){md-toolbar.o-light-table-header{top:96px}}md-toolbar.o-light-table-header.no-padding{padding:0px}md-toolbar.o-light-table-header md-checkbox{width:50px;height:18px;margin-left:3px;padding:0px 12px 0px 60px}md-toolbar.o-light-table-header div{font-weight:bold;font-size:16px}md-list{overflow-y:auto;height:calc(100% - (48px + 16px));height:-moz-calc(100% - (48px + 16px));height:-webkit-calc(100% - (48px + 16px))}md-list md-list-item{cursor:pointer}md-list md-list-item md-checkbox[disabled]{cursor:pointer}md-list md-list-item md-icon{margin-left:15px;font-size:30px}
  `],
  providers: [OntimizeService],
  inputs: [
    ...DEFAULT_INPUTS_O_LIGHT_TABLE
  ],
  outputs: [
    ...DEFAULT_OUTPUTS_O_LIGHT_TABLE
  ],
  encapsulation: ViewEncapsulation.None
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: Router, },
{type: ActivatedRoute, },
{type: ElementRef, },
{type: NgZone, },
{type: Injector, },
{type: OFormComponent, decorators: [{ type: Optional }, { type: Inject, args: [forwardRef(() => OFormComponent), ] }, ]},
];
}


export class OLightTableModule {
static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  declarations: [OLightTableComponent],
  imports: [OSharedModule, CommonModule, OLightTableColumnModule, OLightTableButtonPanelModule],
  exports: [OLightTableComponent],
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
